<template>
  <div>

      <section>
          <div class="container-fluid text-center mx-auto pt-4">
             <div class="col-12 col-md-8 col-xl-6 noSearch mx-auto">
                 <p class="title my-5">Whoops!</p>

                <div>
                 <img src="@/assets/img/svg/sadFaceIcon.svg" class="img-fluid mb-4">
                 <p class="text">You searched for <router-link to="">Giftz</router-link></p>
                 <p class="title mb-0 mt-4">Nothing matched your search.</p>
                 <p class="text mb-4">Please try again with some other keywords.</p>
                 </div>

                 <div class="my-5">
                     <img src="@/assets/img/svg/SeparatorOR.svg" class="img-fluid">
                 </div>
                 <p class="text1 pb-3">Browse through trending films:</p>
             </div>
          </div>
      </section>


    <!-- NOW SHOWING MOVIES SLIDER -->
    <section>
      <div class="container-fluid my-4">
        <NowShowing />
      </div>
    </section>
  

  </div>
</template>

<script>

import NowShowing from "@/components/partials/nowShowingSlider.vue";

export default {
  name: "noSearchFound",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    NowShowing,
  },

  data() {
    return { 

    };
  }, 
};
</script>

<style scoped>

.noSearch .title{
    font-size: 30px;
    line-height: 34px;
    text-align: center;
    color: #2B2D42;
}

.noSearch .text{
   font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #2B2D42;
}

.noSearch .text1{
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #8D99AE;
}

.sliderDetails{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/noSearchFound.vue